// Maps a strategy id to its hand-written product brief. The transcript renderer
// appends the resolved brief as its final section. Briefs are plain strings
// (markdown-ish prose) shipped as `.ts` modules so they resolve uniformly across
// the client build, the server build, and vitest without bundler `?raw` plumbing.

import { careMattersAnnuityBrief } from './careMattersAnnuity';
import { cmTwoBrief } from './cmTwo';
import { forecareBrief } from './forecare';
import { genericHybridBrief } from './genericHybrid';
import { hybridLifeIraBrief } from './hybridLifeIra';
import { indexedAnnuityCareBrief } from './indexedAnnuityCare';
import { lifeWithRiderBrief } from './lifeWithRider';
import { lincolnMoneyGuardBrief } from './lincolnMoneyGuard';
import { manhattanLifeStcBrief } from './manhattanLifeStc';
import { membershipProgramBrief } from './membershipProgram';
import { nylAssetFlexBrief } from './nylAssetFlex';
import { oaAssetCareBrief } from './oaAssetCare';
import { secureCareBrief } from './secureCare';
import { shortTermCareBrief } from './shortTermCare';
import { traditionalLtcBrief } from './traditionalLtc';

const BRIEFS: Record<ProjectionStrategyId, string> = {
  'cm-two': cmTwoBrief,
  'oa-asset-care': oaAssetCareBrief,
  'nyl-asset-flex': nylAssetFlexBrief,
  'lincoln-money-guard': lincolnMoneyGuardBrief,
  'traditional-ltc': traditionalLtcBrief,
  'forecare': forecareBrief,
  'carematters-annuity': careMattersAnnuityBrief,
  'indexed-annuity-care': indexedAnnuityCareBrief,
  'life-with-rider': lifeWithRiderBrief,
  'membership-program': membershipProgramBrief,
  'short-term-care': shortTermCareBrief,
  'manhattan-life-stc': manhattanLifeStcBrief,
  'hybrid-life-ira': hybridLifeIraBrief,
  'generic-hybrid': genericHybridBrief,
  'secure-care': secureCareBrief,
};

export function getBriefForStrategy(strategyId: ProjectionStrategyId): string {
  return BRIEFS[strategyId];
}
